module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-hello.d0e3a189.png";